import { useEffect, useState } from 'react';
import { Home } from 'lucide-react';
export default function RoomPhoto({ src, alt = 'Foto kamar', className = '' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return src && !failed ? <img src={src} alt={alt} className={className} onError={() => setFailed(true)} /> :
    <div className={`${className} flex flex-col items-center justify-center gap-3 bg-muted text-muted-foreground`} role="img" aria-label="Foto kamar belum tersedia"><Home className="h-12 w-12" /><span className="text-sm">Foto kamar belum tersedia</span></div>;
}
